var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.691 68.17a1 1 0 0 1 -.46-1.888c.781-.4 1.588-.868 2.468-1.42a1 1 0 0 1 1.062 1.7c-.927.58-1.782 1.071-2.612 1.5a1 1 0 0 1 -.458.108z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37 72a34.959 34.959 0 1 1 30.81-18.364 1 1 0 0 1 -1.76-.951 33.01 33.01 0 1 0 -29.05 17.315 32.606 32.606 0 0 0 8.587-1.135 1 1 0 0 1 .526 1.93 34.585 34.585 0 0 1 -9.113 1.205z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60.72 62.36a1 1 0 0 1 -.7-1.717c.715-.7 1.387-1.409 2-2.123a1 1 0 0 1 1.52 1.3c-.65.76-1.364 1.519-2.123 2.257a1 1 0 0 1 -.697.283z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m37 64.625a27.625 27.625 0 1 1 27.625-27.625 27.657 27.657 0 0 1 -27.625 27.625zm0-53.25a25.625 25.625 0 1 0 25.625 25.625 25.654 25.654 0 0 0 -25.625-25.625z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m37 54.5a3.5 3.5 0 0 1 -3.5-3.5v-17a3.5 3.5 0 0 1 7 0v17a3.5 3.5 0 0 1 -3.5 3.5zm0-22a1.5 1.5 0 0 0 -1.5 1.5v17a1.5 1.5 0 0 0 3 0v-17a1.5 1.5 0 0 0 -1.5-1.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37 27.5a4 4 0 1 1 4-4 4 4 0 0 1 -4 4zm0-6a2 2 0 1 0 2 2 2 2 0 0 0 -2-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.3651a3b5.svg";
export { ForwardRef as ReactComponent };